var $ = require('jquery'),
    Uri = require('urijs'),
    scope = require('scope'),
    helper = require('./helpers'),
    xhr = null;

$.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
    if ( options.pushstate ) {
        if (xhr && xhr.readyState !== 4) {
            xhr.abort();
        }
        xhr = jqXHR;
        var uri = new Uri(options.url);
        uri.addQuery('pushstate', '1');
        options.url = uri.toString();
    }
});
$(document)
    .ajaxSend(function (event, xhr, options) {
        if (options.pushstate) {
            scope.app.loading(true);
        }
    })
    .ajaxComplete(function() {
        scope.app.loading(false);
    })
    .ajaxSuccess(function (event, xhr, options, response) {
        if (options.pushstate) {
            if (response.sections) {
                if (!options.nosetup) {
                    scope.app.setup(response, false, function() {
                        // helper.anchor(response.data.scroll || 0);
                        scope.app.loading(false);
                    });
                    if (window.location.hash){
                        var target = $(window.location.hash);
                        if (target.length > 0){
                            helper.scrollTo(target);
                        }
                    }
                    scope.app.trigger('change:sections', response.sections);
                }

            } else if (response.redirect) {
                scope.app.router.navigate(response.redirect, true);
            }
        }
    })
    .ajaxError(function (event, xhr, options) {
        if (options.pushstate) {
            scope.app.loading(false);
            if (xhr.responseJSON && xhr.responseJSON.redirect) {
                scope.app.router.navigate(xhr.responseJSON.redirect);
            }
        }
    });



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/libs/ajax.js
// module id = 19
// module chunks = 14 15